import { __awaiter } from 'tslib';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { EthProviderHelper } from './ethProviderHelper.js';
import { EthProvider } from './ethProvider.js';

class MetaMask extends EthProvider {
    constructor() {
        super(...arguments);
        this.name = 'MetaMask';
        this.supportedChains = ['ETH', 'EVM'];
        this.connectedChain = 'EVM';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = false;
        this.isWalletConnect = false;
        this.ethProviderHelper = new EthProviderHelper();
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupEventListeners(listeners) {
        return this.ethProviderHelper._setupEventListeners(listeners, this.getWeb3Provider());
    }
    teardownEventListeners() {
        return this.ethProviderHelper._teardownEventListeners(this.name);
    }
    getWeb3Provider() {
        return this.ethProviderHelper.findProvider(this.name);
    }
    isInstalledOnBrowser() {
        return this.ethProviderHelper.isInstalledHelper(this.name);
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchPublicAddress();
        });
    }
    fetchPublicAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.ethProviderHelper.fetchPublicAddressWithName(this.name);
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.ethProviderHelper.signMessageWithName(messageToSign, this.name);
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signMessage(messageToSign);
        });
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            // nothing to do on browser-based metamask
            return;
        });
    }
    providerSwitchNetwork({ network, provider, }) {
        const _super = Object.create(null, {
            providerSwitchNetwork: { get: () => super.providerSwitchNetwork }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.providerSwitchNetwork.call(this, { network, provider });
        });
    }
}

export { MetaMask as default };
